/**
 * MobileAuth.jsx
 * Used by native mobile applications to initialize external user session and
 * redirect to the target location
 */

import React from 'react';
import moment from 'moment';
import axios from 'axios';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';

import LocalStorage from '../helpers/storage/LocalStorage';
import CookieStorage from '../helpers/storage/CookieStorage';
import { isLoggedIn, getRecAccount } from '../helpers/securityHelper';
import Loading from './../components/sharedComponents/Loading';
import { loggedIn } from './../actions/navigation/loginActions'
import NotificationsWrapper from '../components/notifications/NotificationsWrapper';

const propTypes = {
    dispatch: PropTypes.func
};

export class MobileAuth extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isError: false,
            errorMessage: ''
        };
    }

    componentDidMount() {
        this.initUserSession();
    }

    initUserSession = async () => {
        const nextUri = get(this.props, 'location.query.next', null);
        if (!this.isValidURI(nextUri)) {
            this.setState({
                isLoading: false,
                isError: true,
                errorMessage: 'Malformed request - invalid next'
            });
            return;
        }

        if (!isLoggedIn()) {
            const accessToken = new CookieStorage().readCookie('X-Mobile-Auth');
            if (accessToken === null) {
                this.setState({
                    isLoading: false,
                    isError: true,
                    errorMessage: 'Malformed request - missing authentication'
                });
                return;
            }
            try {
                const url = `${process.env.API}/accounts/account`;
                const response = await axios.get(url, { headers: { Authorization: `Bearer ${accessToken}` } });
                const account = response.data;
                LocalStorage.setItem('recaccount', JSON.stringify({
                    access_token: accessToken,
                    account,
                    expiration: moment().add(1, 'hours').format()
                }));

                if (window.dataLayer) {
                    window.dataLayer.push({
                        userID: account.account_id
                    });
                }
                this.redirectToNext(nextUri);
                return;
            }
            catch (error) {
                let errorMessage = `${error}`;
                if (error.response && error.response.data && error.response.data.error) {
                    errorMessage = `${error}: ${error.response.data.error}`
                }
                this.setState({
                    isLoading: false,
                    isError: true,
                    errorMessage
                });
                return;
            }
        }

        this.redirectToNext(nextUri);
    };

    redirectToNext = (nextUri) => {
        const pathname = get(this.props, 'location.query.pathname', null);
        if (pathname) {
            // check if target uri is of the same prefix as the current bundle
            // if yes, then redirect without reloading page
            const pathContext = `/${pathname.split("/")[0]}`
            const nextContext = `/${nextUri.split("/")[0]}`
            if (pathContext === nextContext) {
                this.props.dispatch(loggedIn(getRecAccount()));
                window.assign(nextUri);
                return;
            }
        }
        document.location = nextUri;
    };

    isValidURI = (str) => {
        if (!str) {
            return false;
        }
        const a = document.createElement('a');
        a.href = str;
        return (a.hostname === window.location.hostname);
    };

    render() {
        if (this.state.isError) {
            return (
                <NotificationsWrapper noticeType="error" closeButton={false}>
                    <div className="rec-notification-title-single-row">Error loading your account:</div>
                    <p>There was an error logging into your account. Please go back and try again or log out and log back in again into the application.</p>
                    <p>{this.state.errorMessage}</p>
                </NotificationsWrapper>
            )
        }
        return <Loading />;
    }
}

MobileAuth.propTypes = propTypes;

export default connect(() => {
    return {};
})(MobileAuth);
